/**
 * KashIO Core EXT r.1.0.0.a
 * KashIO Core API-EXT Release 1.0.0.alpha
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable, } from '@angular/core';
import {
    HttpClient, HttpHeaders,
    HttpResponse, HttpEvent
} from '@angular/common/http';

import { Observable } from 'rxjs';

import { Payment } from '../_models/payment.interface';

import { AppConfig } from '../_helpers/appconfig.service';


@Injectable()
export class PaymentService {

    public defaultHeaders = new HttpHeaders();

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();
    httpOptions: any;

    constructor(protected httpClient: HttpClient

    ) {

    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * create_payment
     * Create a Payment
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPayment(body: Payment, observe?: 'body', reportProgress?: boolean): Observable<Payment>;
    public createPayment(body: Payment, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Payment>>;
    public createPayment(body: Payment, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Payment>>;
    public createPayment(body: Payment, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createPayment.');
        }

        return this.httpClient.post<Payment>(`${this._kcmssvcURL}/payments`,
            body,
            {

            }
        );
    }

    /**
     * get_payment
     * Get a Payment
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPayment(publicId: string, observe?: 'body', reportProgress?: boolean): Observable<Payment>;
    public getPayment(publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Payment>>;
    public getPayment(publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Payment>>;
    public getPayment(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getPayment.');
        }

        return this.httpClient.get<Payment>(`${this._kcmssvcURL}/payments/${encodeURIComponent(String(publicId))}`,
            {

            }
        );
    }

}
